<template>
    <div class="container">
        <div class="handle-box-search">
            <div class="handle-box">
                <el-row class="head-search">
                    <el-col :span="12">
                        <span class="title">领取人手机号:</span>
                        <!-- 搜索司机名称-->
                        <el-input
                            v-model="search_data.consumer_phone"
                            placeholder="请输入领取人手机号"
                            class="handle-input mr10"
                            @keyup.enter.native="searchPackageReceiveLists"
                            maxlength="11"
                            style="width: 200px"
                        ></el-input>
                    </el-col>
                    <el-col :span="12">
                        <span class="title">使用状态:</span>
                        <el-select
                            v-model="search_data.status"
                            placeholder="请选择"
                            clearable
                            @keyup.enter.native="searchPackageReceiveLists"
                        >
                            <el-option label="未使用" value="0"> </el-option>
                            <el-option label="已使用" value="1"> </el-option>
                        </el-select>
                    </el-col>
                    
                </el-row>
                <el-row class="head-search">
                    
                    <el-col :span="24">
                        <span class="title">领取时间:</span>
                        <!-- 搜索司机名称-->
                        <el-date-picker
                            v-model="search_time"
                            type="datetimerange"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            @change="timeChange"
                            style="width: 350px"
                        >
                        </el-date-picker>
                    </el-col>
                </el-row>
            </div>

            <div>
                <el-button type="primary" icon="el-icon-search" @click="searchPackageReceiveLists">搜索</el-button>

                <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            </div>
        </div>

        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column prop="id" label="id"> </el-table-column>

            <el-table-column prop="name" label="领取人姓名"> </el-table-column>

            <el-table-column prop="phone" label="领取人手机号"> </el-table-column>

            <el-table-column prop="receive_time.YmdHis" label="领取时间"> </el-table-column>

            <el-table-column label="使用状态">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status == '未使用' ? 'danger' : 'success'">
                        {{ scope.row.status }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button @click="useCouponPackageLogBtn(scope.row.package_code, scope.row.consumer_code)"> 使用记录 </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>

        <!-- 添加组件 -->
        <useCouponPackageLog
            :isShow="details_isShow"
            :children_data="children_data"
            :consumer_code="consumer_code"
            @onSubmit="packageList"
        ></useCouponPackageLog>
    </div>
</template>

<script>
var _this;
import useCouponPackageLog from './useCouponPackageLog.vue';
import editCouponPackageList from './editCouponPackageList.vue';
export default {
    components: {
        useCouponPackageLog,
        editCouponPackageList
    },
    data() {
        return {
            // 添加用户信息组件开关
            details_isShow: false,
            search_time: '',

            children_data: '',
            consumer_code: '',

            // 存放表格数据
            tableData: [],

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                status: '',
                consumer_phone: '',
                use_time_stamp: '',
                package_code: ''
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        if (_this.$route.query.package_code) {
            _this.search_data.package_code = _this.$route.query.package_code;
        }

        _this.searchPackageReceiveLists();
    },
    mounted() {
        console.log(this.$route.query);
    },
    methods: {
        timeChange(val) {
            console.log(val,'val');
            if (val != null) {
                _this.search_data.receive_time_stamp = JSON.stringify(['between'].concat(val));
            } else {
                _this.search_data.receive_time_stamp = '';
            }
        },
        useCouponPackageLogBtn(code, consumer_code) {
            _this.children_data = code;
            _this.consumer_code = consumer_code;
            _this.details_isShow = !_this.details_isShow;
        },

        editCoupon(code) {
            _this.edit_isShow = !_this.edit_isShow;
            _this.children_data = code;
        },

        selectPages_coupon_function(search_data) {
            _this.coupon_options_data.page = search_data;

            _this.couponList();
        },
        couponList() {
            _this
                .$post('/coupon/CouponModeLists', _this.coupon_options_data)
                .then((res) => {
                    _this.selectPages_coupon_data = res;
                    _this.options_package_code = res.data;
                })
                .catch((err) => {});
        },
        couponChange(val) {
            _this.search_data.coupon_mode_code = val;
        },

        toExport() {
            _this.getExcelData();
        },

        toDetails(code) {
            this.$router.push({
                path: 'couponRecordLists',
                query: {
                    package_code: code
                }
            });
        },

        searchPackageReceiveLists() {
            _this.search_data.page = 1;
            _this.packageList();
        },

        packageList() {
            _this
                .$post('/package/couponPackageReceiveLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.packageList();
        },
        reset() {
            _this.search_data.package_code = '';
            _this.search_data.name = '';
            _this.packageList();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 200px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
.img {
    display: block;
    width: 120px;
    height: 120px;
}
</style>
